import { Material, Matrix3, Texture } from "three";

// der folgende Code ist kopiert von WebGLMaterials.js / refreshUniformsCommon (Zeile 108)
// und gibt zu einem Material die für die uvTransform relevante Map zurück
export const GetMaterialUvTransformMap = (material: Material): Texture | null | undefined => {
  let uvScaleMap: Texture | null | undefined;
  const mat = material as any;

  if (mat.map) {
    uvScaleMap = mat.map;
  } else if (mat.specularMap) {
    uvScaleMap = mat.specularMap;
  } else if (mat.displacementMap) {
    uvScaleMap = mat.displacementMap;
  } else if (mat.normalMap) {
    uvScaleMap = mat.normalMap;
  } else if (mat.bumpMap) {
    uvScaleMap = mat.bumpMap;
  } else if (mat.roughnessMap) {
    uvScaleMap = mat.roughnessMap;
  } else if (mat.metalnessMap) {
    uvScaleMap = mat.metalnessMap;
  } else if (mat.alphaMap) {
    uvScaleMap = mat.alphaMap;
  } else if (mat.emissiveMap) {
    uvScaleMap = mat.emissiveMap;
  } else if (mat.clearcoatMap) {
    uvScaleMap = mat.clearcoatMap;
  } else if (mat.clearcoatNormalMap) {
    uvScaleMap = mat.clearcoatNormalMap;
  } else if (mat.clearcoatRoughnessMap) {
    uvScaleMap = mat.clearcoatRoughnessMap;
  } else if (mat.specularIntensityMap) {
    uvScaleMap = mat.specularIntensityMap;
  } else if (mat.specularColorMap) {
    uvScaleMap = mat.specularColorMap;
  } else if (mat.transmissionMap) {
    uvScaleMap = mat.transmissionMap;
  } else if (mat.thicknessMap) {
    uvScaleMap = mat.thicknessMap;
  } else if (mat.sheenColorMap) {
    uvScaleMap = mat.sheenColorMap;
  } else if (mat.sheenRoughnessMap) {
    uvScaleMap = mat.sheenRoughnessMap;
  }

  if ((uvScaleMap as any)?.isWebGLRenderTarget) {
    uvScaleMap = (uvScaleMap as any).texture;
  }

  return uvScaleMap;
};

export const GetMaterialUvTransform = (material: Material): Matrix3 | undefined => {
  const uvScaleMap = GetMaterialUvTransformMap(material);

  if (uvScaleMap && uvScaleMap.matrixAutoUpdate) {
    uvScaleMap.updateMatrix();
  }

  return uvScaleMap?.matrix;
};
